module.exports = __webpack_public_path__ + "img/payroll02.6587d9e7.jpeg";